exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profileRequests-d3704{padding:24px}.loading-a2a3c{display:flex;align-items:center;justify-content:center;width:100%;height:300px}.attachment-4776c{color:#1677ff;cursor:pointer}", ""]);

// Exports
exports.locals = {
	"profileRequests": "profileRequests-d3704",
	"loading": "loading-a2a3c",
	"attachment": "attachment-4776c"
};